<template>
    <div class="schoolCard-detail">
      <template v-if="data.SystemUpgrading" >
        <SystemUpdating/>
      </template>
      <template v-else>
        <div class="details-center">
          <div class="box1">
            <p>{{data.balance || '-'}}</p>
            <span>当前余额</span>
          </div>
          <div class="box2" v-if="schoolCode !== 'jimeidaxue'">
            <p>{{data.lastIncome && data.lastIncome.length > 0 && data.lastIncome[0].amount || '-'}}</p>
            <span>上次充值</span>
          </div>
          <div class="box3" v-if="schoolCode !== 'jimeidaxue'">
            <p>{{data.monthBalance || '-'}}</p>
            <span>本月消费</span>
          </div>
        </div>
        <hr>
        <div class="details-recode" v-if="schoolCode !== 'jimeidaxue'">
          <ul v-for="(item, index) in data.lastExpenditure" :key="index">
            <li class="details-recode-time">{{item.time && item.time.substring(0,16)  || '-'}}</li>
            <li class="details-recode-site">{{item.payWay || '-'}}</li>
            <li class="details-recode-consume">{{item.amount || '-'}}</li>
          </ul>
        </div>
        <GoMore v-if="schoolCode !== 'jimeidaxue'"  text="更多消费记录&gt;&gt;" jumRouter="MyCost"/>
      </template>

    </div>
    
</template>

<script>
    import GoMore from "./GoMore"
    import SystemUpdating from "./SystemUpdating"
    export default {
        name: "SchoolCode",
        components: {
            GoMore,
          SystemUpdating
        },
        props: {
            data:  { type: Object, default:()=>{}},
          schoolCode: { type: String, default: ''}

        },
    }
</script>

<style scoped lang="scss">
    .schoolCard-detail {
        height: 253px;
        background: #e8eaf3;
        text-align: center;
        .details-center {
            display: flex;
            justify-content: space-around;
           padding-top: 30px;
            .box1,.box2,.box3 {
                text-align: center;
                p {
                    font-size: 28px;
                    color: #3a3550;
                }
                span {
                    font-size: 12px;
                    color: #3a3550;
                }
            }

        }
        hr {
            border: 1px dashed #995a73;
            width: 90%;
          margin: 19px auto 15px;
        }
        .details-recode {
            padding-left: 10px;
            padding-right: 20px;
            height: 75px;
            overflow: hidden;
            ul {
                display: flex;
                justify-content: flex-start;
                padding-left: 18px;
                padding-right: 20px;
                line-height: 25px;
                li {
                    font-size: 12px;
                    color: #3a3550;
                   &.details-recode-time {
                       width: 120px;
                       text-align: left;
                   }
                    &.details-recode-site {
                        flex: 1;
                        text-align: left;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;

                    }
                    &.details-recode-consume {
                        width: 50px;
                        text-align: right;

                    }
                }

            }
        }
        .more-recode {
            margin-top: 15px;
            padding-right: 31px;
            text-align: right;
            font-size: 12px;
            color: #3a3550;
        }



    }

</style>